import { motion } from 'framer-motion';

const AnimatedWordsMarkdown = ({ text, className = '' }) => {
  // Text in Zeilen aufteilen
  const lines = text.split('\n');

  // Funktion zum Rendern von Wörtern
  const renderWords = line => {
    const regex = /(\*\*(.*?)\*\*)|(\S+)/g;
    const matches = line.matchAll(regex);

    return Array.from(matches).flatMap((match, index) => {
      const isBold = match[1]; // Prüfen, ob der Text fettgedruckt ist
      const content = isBold ? match[2] : match[0];

      const words = content.split(' ');

      return words.map((word, wordIndex) => (
        <motion.span
          key={`word-${index}-${wordIndex}`}
          className={`${className} uppercase tracking-wider mx-2 ${isBold ? 'font-bold' : ''}`}
          variants={{
            hidden: { opacity: 0, y: 10 },
            visible: { opacity: 1, y: 0 },
          }}
          transition={{ duration: 0.5, ease: 'easeOut' }}
          style={{ lineHeight: '1.1' }}
        >
          {word}
        </motion.span>
      ));
    });
  };

  return (
    <motion.div
      style={{
        overflow: 'hidden',
        whiteSpace: 'normal',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
      initial="hidden"
      animate="visible"
      variants={{
        visible: {
          transition: {
            staggerChildren: 0.2, // Verzögerung zwischen den Zeilen
          },
        },
      }}
    >
      {lines.map((line, lineIndex) => (
        <motion.div
          key={lineIndex}
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'center',
            minHeight: line.trim() === '' ? '2em' : 'auto',
          }} // Flexbox für die Wörter
        >
          {line.trim() === '' ? ( // Überprüfen, ob die Zeile leer ist
            <motion.div
              style={{ width: '100%', height: '2em' }} // Leerzeile mit Höhe
            />
          ) : (
            renderWords(line)
          )}
        </motion.div>
      ))}
    </motion.div>
  );
};

export default AnimatedWordsMarkdown;
